// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__sPa1D","head":"ProcedureTableInfo_head__u-wNu"};